import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { LegacySection } from './components/LegacySection';
import { BestSellingSection } from './components/BestSellingSection';
import { ParallaxBreakSection } from './components/ParallaxBreakSection';
import { WineFeatureSection } from './components/WineFeatureSection';
import { VineyardSection } from './components/VineyardSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white w-full overflow-x-hidden" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <LegacySection data-id="element-4" />
        <BestSellingSection data-id="element-5" />
        <ParallaxBreakSection data-id="element-6" />
        <WineFeatureSection data-id="element-7" />
        <VineyardSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}